import { Link, useNavigate } from "react-router-dom";
import { RoutesLink } from "../../ApiHelper/RoutesLink";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import {
  saveActiveArRequestsTab,
  saveActiveEmpOnboardTab,
  saveActiveLeaveRequestsTab,
  saveActiveOdRequestsTab,
  saveActivePtAgainstPoTab,
  saveActivePtGeneralTab,
  saveActivePurchaseOrderTab,
  saveActivePurchaseRequestTab,
  saveActivePurchaseTab,
  saveActiveSalaryHeadTab,
  saveActiveSidebarTab,
  saveActiveSiteDetailTab,
  saveActiveSummaryTab,
  saveNotifications,
  saveNotificationsCount,
  saveSideBarScrollPosition,
  saveUserDetails,
  updateDateFilter,
  updateFiltersStates,
} from "../../store/actions/UserActions";
import UserHeader from "./UserHeader";
import { callApi } from "../../ApiHelper/ApiHelper";
import { apiUrl } from "../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import {
  getCurrentFinancialYear,
  timeAgo,
} from "../../utility/CommonFunctions";
import LineLoader from "../Loaders/LineLoader";
import LogoutModal from "../comman/LogoutModal";
import moment from "moment";

const Header = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [logoutLoading, setLogoutLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const toggle = () => {
    setModal(!modal);
  };
  const userDetails = useSelector((state) => state.root.userDetails);
  const notificationCount = useSelector(
    (state) => state?.root?.notificationCount
  );
  const notifications = useSelector((state) => state?.root?.notifications);

  useEffect(() => {
    getNotificationCount();
  }, []);

  const getNotificationList = () => {
    setIsLoading(true);
    const apiURL = apiUrl?.get_notification;
    const options = {
      method: "GET",
    };
    callApi(apiURL, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        dispatch(saveNotifications(response?.data?.notification));
        if (notificationCount?.unseenNotitfication > 0) {
          dispatch(
            saveNotificationsCount({
              ...notificationCount,
              unseenNotitfication: 0,
            })
          );
        }
      }
    });
  };

  const getNotificationCount = () => {
    const apiURL = apiUrl?.get_notification_count;
    const options = {
      method: "GET",
    };
    callApi(apiURL, options).then((response) => {
      if (response?.status === true) {
        dispatch(saveNotificationsCount(response?.data));
        if (response?.data?.willRefreshSystem) {
          HandleLogout();
        }
      }
    });
  };

  const HandleLogout = () => {
    const deviceId = localStorage.getItem("deviceId");
    const options = {
      method: "GET",
    };
    let API = apiUrl?.logout + `?deviceId=${deviceId}`;
    setLogoutLoading(true);
    callApi(API, options).then((response) => {
      setLogoutLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        dispatch(saveUserDetails({}));
        dispatch(saveNotifications([]));
        dispatch(saveNotificationsCount({}));
        dispatch(saveSideBarScrollPosition(0));
        dispatch(saveActiveSidebarTab(0));
        dispatch(saveActiveSiteDetailTab(1));
        dispatch(saveActiveLeaveRequestsTab(1));
        dispatch(saveActiveArRequestsTab(1));
        dispatch(saveActiveOdRequestsTab(1));
        dispatch(saveActiveEmpOnboardTab(1));
        dispatch(saveActiveSummaryTab(1));
        dispatch(saveActivePurchaseTab(""));
        dispatch(saveActivePurchaseRequestTab(1));
        dispatch(saveActivePurchaseOrderTab(""));
        dispatch(saveActivePtAgainstPoTab("pending"));
        dispatch(saveActivePtGeneralTab("pending"));
        dispatch(saveActiveSalaryHeadTab(1));
        dispatch(
          updateFiltersStates({
            currentPage: 1,
            pageSize: 10,
            count: 0,
            totalPages: 0,
            sortByDate: [
              moment(moment().subtract(30, "days").toDate()).format(
                "YYYY-MM-DD"
              ),
              moment(moment().toDate()).format("YYYY-MM-DD"),
            ],
            year: getCurrentFinancialYear(),
            companyId: "",
            siteId: "",
            department: "",
            designation: "",
            requestType: "",
            stockStatus: "",
            vendorId: "",
            empStatus: "current",
          })
        );
        dispatch(
          updateDateFilter([
            moment().startOf("month").format("YYYY-MM-DD"),
            moment().endOf("month").format("YYYY-MM-DD"),
          ])
        );
        Cookies.remove("token");
        Cookies.remove("refreshToken");
        localStorage.removeItem("token");
        localStorage.removeItem("fcmToken");
        new BroadcastChannel("auth").postMessage({
          type: "logout",
          sourceTabId: window.__TAB_ID,
        });
        window.location.reload();
        navigate(RoutesLink.login);
      } else {
        toast.error(response?.message);
      }
    });
  };

  // const handleNavigateTabs = (item) => {
  //   if (
  //     item?.notificationData?.key &&
  //     item?.notificationData?.key == "new_Userreport"
  //   ) {
  //     dispatch(activeReportsTab(1));
  //   }
  //   if (
  //     item?.notificationData?.key &&
  //     item?.notificationData?.key == "new_Postreport"
  //   ) {
  //     dispatch(activeReportsTab(2));
  //   }

  // };

  return (
    <>
      {userDetails?.type === 2 ? (
        <header className="header shadow-sm bg-white" style={{ borderBottom: "1px solid #dee2e6" }}>
          <nav className="navbar navbar-expand-lg py-1">
            <div className="container-fluid">
              <div className="collapse navbar-collapse justify-content-between align-items-stretch ">
                <button
                  className="btn btn-toggle border-0 d-none"
                  id="toggleButton"
                  type="button"
                >
                  <i className="fas fa-bars" />
                </button>
                <div className="header-nav d-flex align-items-stretch justify-content-between w-100">
                  <div className="user d-flex align-items-center">
                    <div>
                      <h6 className="title mb-0 fw-bold">
                        {userDetails?.name?.toUpperCase()}
                      </h6>
                    </div>
                  </div>
                  <ul className="d-flex align-items-center gap-4 list-unstyled mb-0">
                    <li>
                      <div className="dropdown">
                        <button
                          className="btn notif border-0 bg-transparent position-relative d-flex align-items-center justify-content-center dropdown-toggle"
                          style={{ width: "32px", height: "32px" }}
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          onClick={getNotificationList}
                        >
                          <i className="far fa-bell text-primary" style={{ fontSize: "16px" }} />
                          {notificationCount?.unseenNotitfication > 0 && (
                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                              {notificationCount?.unseenNotitfication > 99
                                ? "99+"
                                : notificationCount?.unseenNotitfication}
                            </span>
                          )}
                        </button>
                        <ul className="dropdown-menu shadow notification-dropdown">
                          <li className="p-2 bg-primary text-white">
                            <h3 className="fw-light">Notifications</h3>
                          </li>
                          <li className="body">
                            <ul className="list-unstyled">
                              {isLoading && <LineLoader />}
                              {notifications && notifications?.length > 0
                                ? notifications?.map(
                                  (item, i) =>
                                    i < 10 && (
                                      <li key={i}>
                                        <Link
                                          to={
                                            item?.data?.type &&
                                            ((item?.data?.type ==
                                              "attendance" &&
                                              RoutesLink?.ar_request_detail +
                                              `/${item?.data?.[
                                              item?.data?.type + "Id"
                                              ]
                                              }`) ||
                                              (item?.data?.type ==
                                                "odRequest" &&
                                                RoutesLink?.od_request_detail +
                                                `/${item?.data?.[
                                                item?.data?.type + "Id"
                                                ]
                                                }`) ||
                                              (item?.data?.type == "leave" &&
                                                RoutesLink?.leave_detail +
                                                `/${item?.data?.[
                                                item?.data?.type + "Id"
                                                ]
                                                }`) ||
                                              (item?.data?.type ==
                                                "purchaseRequest" &&
                                                RoutesLink?.purchase_request_detail +
                                                `/${item?.data?.[
                                                item?.data?.type + "Id"
                                                ]
                                                }`) ||
                                              (item?.data?.type ==
                                                "budgetRequest" &&
                                                RoutesLink?.budget_requests) ||
                                              (item?.data?.type ==
                                                "paymentTicket" &&
                                                RoutesLink?.payment_tickets_details +
                                                `/${item?.data?.[
                                                item?.data?.type + "Id"
                                                ]
                                                }`))
                                          }
                                          state={
                                            item?.data?.type == "leave"
                                              ? userDetails?.type == 2
                                                ? { type: "request" }
                                                : { type: "teamLeaveRequest" }
                                              : null
                                          }
                                        >
                                          <div
                                            className="d-flex justify-content-between"
                                          // onClick={() => handleNavigateTabs(item)}
                                          >
                                            <h4 className="title mb-0">
                                              {item?.data?.title}
                                            </h4>
                                            <span className="time">
                                              {timeAgo(item?.createdAt)}
                                            </span>
                                          </div>
                                          <p>{item?.data?.message}</p>
                                        </Link>
                                      </li>
                                    )
                                )
                                : !isLoading && (
                                  <li className="text-muted text-center">
                                    <p>No Notifications</p>
                                  </li>
                                )}
                            </ul>
                          </li>

                          <li className="p-2 bg-primary text-white">
                            <a
                              className="fs-4 text-center d-block"
                              onClick={() =>
                                navigate(RoutesLink?.notifications)
                              }
                            >
                              View All
                            </a>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div className="dropdown">
                        <button
                          className="btn border-0 bg-transparent d-flex align-items-center justify-content-center dropdown-toggle"
                          style={{ width: "32px", height: "32px" }}
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="far fa-user text-primary" style={{ fontSize: "16px" }} />
                        </button>
                        <ul className="dropdown-menu shadow">
                          <li>
                            <a
                              className="dropdown-item"
                              role="button"
                              onClick={toggle}
                            >
                              <i className="fas fa-door-open" />
                              Logout
                            </a>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </nav>
        </header>
      ) : (
        <UserHeader
          getNotification={getNotificationList}
          notificationCount={notificationCount}
          isloading={isLoading}
        />
      )}
      <LogoutModal
        modal={modal}
        toggle={toggle}
        HandleLogout={HandleLogout}
        logoutLoading={logoutLoading}
      />
    </>
  );
};
export default Header;
